import { defineComponent as K, useSlots as Z, computed as C, useTemplateRef as q, ref as b, watchEffect as G, onMounted as H, onBeforeUnmount as J, createElementBlock as y, openBlock as d, Fragment as Q, createVNode as g, renderSlot as u, unref as i, withCtx as k, Transition as N, createBlock as W, createCommentVNode as p, withModifiers as P, normalizeClass as x, mergeProps as R, withDirectives as X, normalizeProps as f, guardReactiveProps as c, createElementVNode as Y, toDisplayString as _, nextTick as D } from "vue";
import { RevBackdrop as ee } from "@ds/components/Backdrop";
import { RevButtonIcon as te } from "@ds/components/ButtonIcon";
import { RevPortal as oe } from "@ds/components/Portal";
import { vFocus as ae } from "../../directives/focus.js";
import le from "../../icons/generated/IconCross.vue2.js";
import { useI18n as se } from "@ds/plugin";
import ne from "../../translations/generic.translations.js";
import { tw as a } from "../../utils/tailwind.js";
import { defaultModalTransitionClasses as ie } from "./ModalBase.constant.js";
import { onModalUpdate as re, isModalOpened as I, openModal as de, closeModal as ue } from "./ModalBase.helpers.js";
const fe = ["aria-label"], ce = {
  key: 0,
  class: "text-static-default-hi body-1"
}, he = /* @__PURE__ */ K({
  name: "RevModalBase",
  inheritAttrs: !1,
  __name: "ModalBase",
  props: {
    name: {},
    title: { default: "" },
    closeButtonLabel: { default: () => {
    } },
    hasPadding: { type: Boolean, default: !0 },
    backdropZIndex: { default: "z-10" },
    backdropBackgroundColor: { default: () => {
    } },
    backgroundColor: { default: "mid" },
    transitionClassNames: { default: () => ie },
    hasBodyOverflow: { type: Boolean, default: !0 },
    to: { default: "body" },
    defer: { type: Boolean, default: !1 },
    disableCloseOnBackdropClick: { type: Boolean, default: !1 }
  },
  emits: ["open", "close"],
  setup(e, { emit: O }) {
    const m = Z(), h = O, S = C(() => [
      m.body && a`fixed bottom-0 left-0 flex max-h-dvh w-full flex-col justify-between`,
      m.body && {
        mid: a`bg-surface-default-mid`,
        low: a`bg-surface-default-low`
      }[e.backgroundColor]
    ]), E = C(
      () => m.body && [
        a`relative mx-24 mt-16`,
        e.title ? [
          a`flex items-center justify-center px-40 pb-20 pt-8 text-center after:border-static-default-low after:absolute after:bottom-0 after:border-b after:content-['']`,
          e.hasPadding ? a`after:inset-x-0` : a`after:-inset-x-24`
        ] : a`h-52`
      ]
    ), z = C(
      () => m.body && [
        a`grow`,
        e.hasBodyOverflow ? a`overflow-auto` : a`overflow-hidden`,
        e.hasPadding && [a`safari-mobile-26:pb-0 p-24`, !e.title && a`pt-0`]
      ]
    ), A = se(), L = e.closeButtonLabel || A(ne.buttonClose), U = q("close-button");
    async function V() {
      await D(), await D(), U.value?.$el.focus();
    }
    const w = b(), s = b(!1), v = b(!1);
    G(async () => {
      s.value && await V();
    });
    const B = b(), M = (t) => {
      B.value = t?.target, de(e.name);
    }, l = (t) => {
      ue(
        e.name,
        t && "cause" in t ? t : void 0
      ), B.value?.focus(), B.value = void 0;
    };
    function j(t) {
      s.value = t.opened, window.document.body.style.overflow = s.value ? "hidden" : "", s.value ? h("open") : h("close", t?.closingEvent);
    }
    function F(t) {
      const { key: o, shiftKey: r, target: $ } = t;
      if (o === "Escape") {
        l({ cause: "dismiss" });
        return;
      }
      if (w.value && o === "Tab") {
        const n = w.value.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (n.length < 2) {
          t.preventDefault();
          return;
        }
        const T = n.length - 1;
        r === !1 && $ === n[T] ? (t.preventDefault(), n[0].focus()) : r === !0 && $ === n[0] && (t.preventDefault(), n[T].focus());
      }
    }
    return H(() => {
      re(e.name, j), I(e.name) && M();
    }), J(() => {
      I(e.name) && l();
    }), (t, o) => (d(), y(Q, null, [
      g(i(oe), {
        defer: e.defer,
        to: e.to
      }, {
        default: k(() => [
          g(N, {
            appear: "",
            "enter-active-class": "motion-safe:transition-opacity motion-safe:duration-300",
            "enter-from-class": "opacity-0",
            "leave-active-class": "motion-safe:transition-opacity motion-safe:duration-200",
            "leave-to-class": "opacity-0"
          }, {
            default: k(() => [
              s.value ? (d(), W(i(ee), {
                key: 0,
                "background-color": e.backdropBackgroundColor,
                class: x(e.backdropZIndex),
                onClick: o[3] || (o[3] = P(
                  () => v.value ? null : l({
                    cause: "backdropClick",
                    disabled: e.disableCloseOnBackdropClick
                  }),
                  ["self"]
                )),
                onMousedown: o[4] || (o[4] = P((r) => v.value = !1, ["self"]))
              }, {
                default: k(() => [
                  g(N, R({ appear: "" }, e.transitionClassNames), {
                    default: k(() => [
                      s.value ? X((d(), y("div", R({ key: 0 }, t.$attrs, {
                        ref_key: "dialog",
                        ref: w,
                        "aria-label": e.title,
                        "aria-modal": "true",
                        class: S.value,
                        role: "dialog",
                        tabindex: "0",
                        onKeydown: F,
                        onMousedown: o[1] || (o[1] = (r) => v.value = !0),
                        onMouseup: o[2] || (o[2] = (r) => v.value = !1)
                      }), [
                        u(t.$slots, "default", f(c({ close: l })), () => [
                          Y("div", {
                            class: x(E.value)
                          }, [
                            u(t.$slots, "beforeTitle", f(c({ close: l }))),
                            e.title ? (d(), y("h2", ce, _(e.title), 1)) : p("", !0),
                            u(t.$slots, "afterTitle", f(c({ close: l })), () => [
                              g(i(te), {
                                ref: "close-button",
                                "alternative-text": i(L),
                                class: "absolute right-0 top-0",
                                icon: i(le),
                                variant: "secondary",
                                onClick: o[0] || (o[0] = () => l({ cause: "dismiss" }))
                              }, null, 8, ["alternative-text", "icon"])
                            ])
                          ], 2),
                          t.$slots.body ? (d(), y("div", {
                            key: 0,
                            class: x(z.value)
                          }, [
                            u(t.$slots, "body", f(c({ close: l })))
                          ], 2)) : p("", !0)
                        ])
                      ], 16, fe)), [
                        [i(ae), !0]
                      ]) : p("", !0)
                    ]),
                    _: 3
                  }, 16)
                ]),
                _: 3
              }, 8, ["background-color", "class"])) : p("", !0)
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["defer", "to"]),
      u(t.$slots, "trigger", f(c({ open: M })))
    ], 64));
  }
});
export {
  he as default
};
